import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const container = document.getElementById('forms-root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <App />
  </LocalizationProvider>
);


// ReactDOM.render(
//   <MuiPickersUtilsProvider utils={MomentUtils}>
//     {/* <React.StrictMode> */}
//       <App />
//     {/* </React.StrictMode> */}
//   </MuiPickersUtilsProvider>,
//   document.getElementById('forms-root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
